import { RouteInfo } from './bankersidebar.metadata';

export const ROUTES: RouteInfo[] = [
  //   {
  //     path: '',
  //     title: 'Personal',
  //     icon: 'mdi mdi-dots-horizontal',
  //     class: 'nav-small-cap',
  //     extralink: true,
  //     submenu: []
  //   },
    {
      path: '/banker/dashboard',
      title: 'Dashboard',
      icon: 'icon-Dashboard',
      class: '',
      extralink: false,
      submenu: []
    },
    {
      path: '/banker/sme-rms',
      title: 'Risk Management System',
      icon: 'icon-Bar-Chart',
      class: '',
      extralink: false,
      submenu: []
    },
    {
      path: '/banker/invoiceDiscount',
      title: 'Bill Lodgement',
      icon: 'icon-Data-Transfer',
      class: '',
      extralink: false,
      submenu: []
    },
    {
      path: '/invoiceDiscount/add',
      title: 'Discounting',
      icon: 'icon-Car-Wheel',
      class: '',
      extralink: false,
      submenu: []
    },
    {
      path: '/invoiceDiscount/liquidation',
      title: 'Liquidation',
      icon: 'icon-Data-Transfer',
      class: '',
      extralink: false,
      submenu: []
    },
    {
      path: '/invoiceDiscount/transaction',
      title: 'Transaction Maintenance',
      icon: 'icon-Data-Transfer',
      class: '',
      extralink: false,
      submenu: []
    },
    {
      path: '/banker/disbursed_Invoices',
      title: 'Disbursed Invoices',
      icon: 'icon-Receipt-3',
      class: '',
      extralink: false,
      submenu: []
    },
    {
      path: '/banker/list/uw',
      title: 'Underwriter',
      icon: 'icon-Checked-User',
      class: '',
      extralink: false,
      submenu: []
    },
    
    {
      path: '/banker/sign-desk',
      title: 'Agreement',
      icon: 'fas fa-pencil-alt',
      class: '',
      extralink: false,
      submenu: []
    },
    {
      path: '/banker/approver/limit',
      title: 'Approver limit',
      icon: 'icon-Data-Transfer',
      class: '',
      extralink: false,
      submenu: []
    },
    {
      path: '/banker/report',
      title: 'Reports',
      icon: 'mdi mdi-dots-horizontal',
      class: '',
      extralink: false,
      submenu: []
    }
  ];
